import React from 'react';
import { childClassNameProp } from '@monorepo/type';

const Body = ({ children, className }: childClassNameProp) => (
  <tbody className={className}>{children}</tbody>
);

export default Body;
